<template>
  <div class="app-engine-analyse-item">
    <div class="analyse-item-header">
      <span class="analyse-item--title">{{ chartConfig.chartName }}</span>
      <x-svg-icon name="refresh" @click.native="handleRefresh"></x-svg-icon>
    </div>
    <div class="analyse-item-content">
      <component
        :is="typeToComponent[chartConfig.chartType]"
        ref="analyseItemChart"
        :chartConfig="chartConfig"
        v-on="$listeners"
      ></component>
    </div>
  </div>
</template>

<script>
import IndicatorChart from '../app-engine-analyse-charts/indicator-chart'
import PieChart from '../app-engine-analyse-charts/pie-chart'
import BarChart from '../app-engine-analyse-charts/bar-chart'
import LineChart from '../app-engine-analyse-charts/line-chart'
import RichTextChart from '../app-engine-analyse-charts/rich-text-chart'
import CalendarChart from '../app-engine-analyse-charts/calendar-chart'

export default {
  components: {
    IndicatorChart,
    PieChart,
    BarChart,
    LineChart,
    RichTextChart,
    CalendarChart
  },
  props: {
    chartConfig: {
      type: Object,
      default() {
        return {}
      }
    }
  },
  data() {
    return {
      typeToComponent: {
        INDICATOR_CHART: 'IndicatorChart',
        PIE_CHART: 'PieChart',
        RICH_TEXT_CHART: 'RichTextChart',
        LINE_CHART: 'LineChart',
        BAR_CHART: 'BarChart',
        CALENDAR_CHART: 'CalendarChart'
      }
    }
  },
  methods: {
    handleRefresh() {
      let refresh = this.$refs.analyseItemChart && this.$refs.analyseItemChart.refresh
      if (typeof refresh === 'function') {
        refresh()
      } else {
        console.warn('analyse chart no refresh method')
      }
    }
  }
}
</script>

<style lang="scss">
.app-engine-analyse-item {
  background-color: $--app-box-bgColor;
  border-radius: $--app-base-border-radius;
  margin-bottom: 0.57rem;
  padding: 0 1.14rem 1.14rem;
  .analyse-item-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 3.286rem;
  }
  .analyse-item-content {
  }
}
</style>
